import {Box, Flex, Text, Image, Button} from '@chakra-ui/react';
import * as React from 'react';
import NextLink from 'next/link';
import mixpanel from 'mixpanel-browser';
import {useCurrentAssetOverview} from '../../hooks/current-asset-overview';

interface BanksyHeroMobileProps {
  mainBackdrop: string;
  midBackdrop: string;
}
export const BanksyHeroMobile: React.FC<BanksyHeroMobileProps> = ({
  mainBackdrop,
  midBackdrop,
}) => {
  const asset = useCurrentAssetOverview('valentines.day.mascara');
  return (
    <Box>
      <Image src={mainBackdrop} alt="banksy valentines day mascara" w="100%" />
      <Box px="20px" mt="40px" mb="20px">
        <Text fontWeight="600" fontSize="30px" mb="15px">
          Banksy: Valentine’s Day Mascara
        </Text>
        <Text fontWeight="600" fontSize="20px" mb="20px">
          Valuation | £6,000,000
        </Text>
        <Text>
          In the heart of the seaside town of Margate, a graffiti mural was
          discovered on Valentine’s Day, 2023. Depicting an archetypal housewife
          closing a fridge on her victim, the piece would appear to be a comedic
          slapstick scene at first glance. However, upon closer inspection, a
          black eye, missing tooth, beer bottle, and frying pan suggested a
          darker tone. This kind of commentary could only come from one artist.
          Banksy.
        </Text>
        <Box mt="20px">
          {asset.status === 'COMING_SOON' ? (
            <NextLink href="/banksy-waitlist">
              <Button
                colorScheme="aqua"
                width="215px"
                onClick={() => {
                  mixpanel.track(
                    'Banksy product page sign up to waitlist click',
                  );
                }}
              >
                Sign up to waitlist
              </Button>
            </NextLink>
          ) : (
            <NextLink href="/own-a-piece/valentines-day-mascara">
              <Button
                colorScheme="aqua"
                width="215px"
                onClick={() => {
                  mixpanel.track('Banksy product page buy click');
                }}
              >
                Buy
              </Button>
            </NextLink>
          )}
        </Box>

        <Box mt="20px" pb="40px">
          <Text
            textStyle="h4"
            fontSize="20px"
            whiteSpace="nowrap"
            textAlign="center"
          >
            As featured in
          </Text>
          <Box pb="10px" pos="relative" overflowX="scroll" width="100%">
            <Flex
              flexDirection="row"
              flexWrap="nowrap"
              alignItems="center"
              justifyContent="flex-start"
            >
              {[
                {
                  icon: 'sky-news-light.png',
                  link: 'https://news.sky.com/story/rarest-stamp-in-the-world-dubbed-mona-lisa-of-stamps-returns-to-uk-after-143-years-12356170',
                },
                {
                  icon: 'bbc-light.png',
                  link: 'https://www.bbc.co.uk/news/uk-57845086',
                },
                {
                  icon: 'independent-light.png',
                  link: 'https://www.independent.co.uk/money/stakes-in-rare-king-edward-viii-penny-snapped-up-b2031172.html',
                },
                {
                  icon: 'ft-light.png',
                  link: 'https://www.ft.com/content/77790ee0-ce9e-4f77-995b-76e7e4f92ca2',
                },
                {
                  icon: 'mail-light.png',
                  link: 'https://www.dailymail.co.uk/femail/article-11411975/Own-share-edition-Charles-Darwins-Origin-Species.html',
                },
              ].map((logo) => {
                return (
                  <NextLink href={logo.link} target="_blank">
                    <Image
                      src={`/assets/banksy/${logo.icon}`}
                      alt="publication logo"
                      ml="25px"
                    />
                  </NextLink>
                );
              })}
            </Flex>
          </Box>
        </Box>
      </Box>
      <Box pos="relative" bg="#00061A" color="white">
        <Box position="absolute" top="0" left="0" w="100%" h="100%" zIndex={0}>
          <Image
            src={midBackdrop}
            alt="banksy valentines day mascara"
            // pos="sticky"
            top="0"
            width="100%"
            height="100vh"
            objectFit="cover"
          />
        </Box>
        <Flex
          px="20px"
          zIndex={1}
          pos="relative"
          minHeight="140vh"
          alignItems="flex-end"
        >
          <Box pb="60px" pt="250px">
            <Text fontWeight="600" fontSize="30px" mb="15px">
              Banksy
            </Text>
            <Text fontSize="18px">
              An enigma of international art, Banksy is the alias of an unknown
              British graffiti artist thought to have emerged from Bristol
              Underground Scene in the 1990s. Since then, Banksy’s work has
              appeared worldwide, from the streets of New York to the West Bank.
              His iconic stencil style often depicts dark humour, satire and
              sociopolitical commentary themes. Except for a limited number of
              works released for sale by Banksy&apos;s representative agency,
              ‘Pest Control’, most of the artists’ work is created on publicly
              visible surfaces.
            </Text>
          </Box>
        </Flex>
      </Box>
    </Box>
  );
};
